import { createUseStyles } from "react-jss";
import { COLORS } from "./defaults";

export const buttonStyles = {
    default: {
        fontSize: "unset",
        fontWeight: "100",
        textAlign: "unset",
        fontFamily: "sans-serif",
    },
    button: {
        margin: "0.2em",
        padding: "0.8em",
        border: "0 none",
        cursor: "pointer",
        borderRadius: "40px",
    },
    purpleBtn: {
        color: COLORS.primary.font,
        backgroundColor: COLORS.primary.main,

        "&:active,&:hover": {
            color: COLORS.primary.main,
            backgroundColor: "ghostwhite",
            boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
        },
    },
    cardOption: {
        padding: "1em",
        cursor: "pointer",
        borderRadius: "1em",
        backgroundColor: "ghostwhite",

        "&:hover": {
            color: COLORS.primary.main,
            boxShadow: "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px"
        }
    },
    marginTB1em: {
        marginTop: "1em",
        marginBottom: "1em"
    },
    alignBtnContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    btnForward: { width: "90%" },
    btnBackward: { minWidth: "1.5em" }
};
export const buttonClasses = createUseStyles(buttonStyles);